import React, { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Elevation from "../../../images/ProgramBaskets/Elevation.png"
import Foundational from "../../../images/ProgramBaskets/Foundational.png"
import Inception from "../../../images/ProgramBaskets/Inception.png"
import Infusion from "../../../images/ProgramBaskets/Infusion.png"
import National from "../../../images/ProgramBaskets/National.png"

const programs = [
	{
		basketId: "6954c31a54baf0a53245f066",
		title: "PRARABDH",
		subtitle: "Foundation Programs",
		image: Foundational,
		buttonText: "KNOW MORE",
		path:"/programs",
		borderColor: "#7AC77A",
		bgColor: "#F4FBF4",
		buttonColor: "#5FBF5F",
	},
	{
		basketId: "6954c31a54baf0a53245f067",
		title: "PRATIBIMB",
		subtitle: "Inception Programs",
		image: Inception,
		buttonText: "KNOW MORE",
		path:"/programs",
		borderColor: "#E3C45B",
		bgColor: "#FFFBEF",
		buttonColor: "#E3AE2A",
	},
	{
		basketId: "6954c31a54baf0a53245f068",
		title: "PRAVAH",
		subtitle: "Infusion Programs",
		image: Infusion,
		buttonText: "KNOW MORE",
		path:"/programs",
		borderColor: "#FF9E7A",
		bgColor: "#FFF6F2",
		buttonColor: "#FF8C5A",
	},
	{
		basketId: "6954c31a54baf0a53245f06a",
		title: "PARIKALPANA",
		subtitle: "National Programs",
		image: National,
		buttonText: "KNOW MORE",
		path:"/programs",
		borderColor: "#D6A7FF",
		bgColor: "#FBF7FF",
		buttonColor: "#B97AFF",
	},
	{
		basketId: "6954c31a54baf0a53245f069",
		title: "PRABODHI",
		subtitle: "Elevation Programs",
		image: Elevation,
		buttonText: "KNOW MORE",
		path:"/programs",
		borderColor: "#84C9FF",
		bgColor: "#F2F9FF",
		buttonColor: "#52B0FF",
	},
];

const AllProgramBaskets = () => {
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate()

	useEffect(() => {
		window.scrollTo({ top: 0, behaviour: "smooth" });
	}, []);

	return (<>
		<Box sx={{textAlign:"center", p:1.5}}>
			<Typography variant="h3" fontWeight={600}>Programs' Basket</Typography>
		</Box>
		<Box
			sx={{
				display: "flex",
				flexWrap: "wrap",
				justifyContent: "center",
				gap: 3,
				p: {xs:2, sm:4, md:6}
			}}
		>
			{programs.map((program) => (
				<Box
					key={program.basketId}
					sx={{
						width: {
							xs: "100%",
							sm: "calc(50% - 12px)",
							md: "calc(33.333% - 16px)",
						},
						maxWidth: {
							md: 380,
							lg: 450,
						},
						p:2,
						backgroundColor: program.bgColor,
						border: `2px solid ${program.borderColor}`,
						borderRadius:"8px"
					}}
				>
					<Box
						component="img"
						src={program.image}
						alt={program.title}
						sx={{
							width: "100%",
							height: 250,
							objectFit: "cover",
							borderRadius: 2,
							mb: 2,
						}}
					/>

					<Box
						sx={{
							mt: "auto",
							display: "flex",
							flexDirection: { xs: "column", sm: "column", lg:"row" },
							justifyContent: "space-between",
							// alignItems: {sm:"flex-end"},
							gap: 2,
						}}
					>
						<Box>
							<Typography
								variant="h5"
								fontWeight={800}
								sx={{
									lineHeight: 1,
									color: "#263245",
								}}
							>
								{program.title}
							</Typography>

							<Typography
								variant="body1"
								sx={{
									color: "#495057",
								}}
							>
								{program.subtitle}
							</Typography>
						</Box>

						<Button
							variant="contained"
							size="small"
							onClick={() => navigate("/programs", {state:{
								selectedBasketId: program.basketId
							}})}
							sx={{
								bgcolor: program.buttonColor,
								borderRadius: 2,
								fontWeight: 700,
								px: 2,
								whiteSpace: "nowrap",
								boxShadow: "none",

								"&:hover": {
									bgcolor: program.buttonColor,
								},
							}}
						>
							{program.buttonText}
						</Button>
					</Box>
				</Box>
			))}
		</Box>
		</>
	);
};

export default AllProgramBaskets;